import type {ReactNode} from "react";
import React, {Children, Fragment} from "react";

import {isReactElement} from "../react";

export function useFilterFragments(node: ReactNode) {
    return Children.toArray(node).flatMap(child => {
        if (isReactElement(child, Fragment)) {
            return React.Children.toArray(child.props.children);
        }
        return child;
    });
}
